import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=02f1ed88&scoped=true&lang=pug&"
import script from "./Global.vue?vue&type=script&lang=ts&"
export * from "./Global.vue?vue&type=script&lang=ts&"
import style0 from "./Global.vue?vue&type=style&index=0&id=02f1ed88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f1ed88",
  null
  
)

export default component.exports